import { render, staticRenderFns } from "./SSOSignUp.vue?vue&type=template&id=5fb73715"
import script from "./SSOSignUp.vue?vue&type=script&lang=js"
export * from "./SSOSignUp.vue?vue&type=script&lang=js"
import style0 from "./SSOSignUp.vue?vue&type=style&index=0&id=5fb73715&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports